// Human-friendly error messages for authentication

const errorMessages: Record<string, string> = {
  // Login errors
  'Invalid login credentials': 'Email or password is incorrect. Please try again.',
  'Email not confirmed': 'Please verify your email address before signing in. Check your inbox for the confirmation link.',
  'Invalid email or password': 'Email or password is incorrect. Please try again.',
  'User not found': 'No account found with this email address.',

  // Registration errors
  'User already registered': 'An account with this email already exists. Try signing in instead.',
  'Password should be at least 6 characters': 'Password must be at least 6 characters long.',
  'Unable to validate email address: invalid format': 'Please enter a valid email address.',
  'Signup requires a valid password': 'Please enter a password.',

  // MFA/OTP errors
  'Invalid TOTP code entered': 'Invalid verification code. Please check and try again.',
  'TOTP code has expired': 'Verification code has expired. Please request a new one.',
  'Invalid one-time password': 'Invalid verification code. Please try again.',

  // Password reset errors
  'Email link is invalid or has expired': 'This reset link has expired. Please request a new one.',
  'New password should be different from the old password': 'Please choose a different password than your current one.',

  // Rate limiting
  'For security purposes, you can only request this once every 60 seconds': 'Please wait a moment before trying again.',
  'Email rate limit exceeded': 'Too many attempts. Please wait a few minutes before trying again.',
  'Request rate limit reached': 'Too many requests. Please wait a moment and try again.',

  // Network errors
  'Failed to fetch': 'Connection error. Please check your internet connection.',
  'Network request failed': 'Connection error. Please check your internet connection.',

  // Session errors
  'Session expired': 'Your session has expired. Please sign in again.',
  'Refresh Token Not Found': 'Your session has expired. Please sign in again.',
  'Invalid Refresh Token': 'Your session has expired. Please sign in again.',

  // Generic
  'An error occurred': 'Something went wrong. Please try again.',
}

export function getAuthErrorMessage(error: string | null | undefined): string {
  if (!error) return 'An unexpected error occurred. Please try again.'

  // Check for exact match first
  if (errorMessages[error]) {
    return errorMessages[error]
  }

  // Check for partial matches
  for (const [key, message] of Object.entries(errorMessages)) {
    if (error.toLowerCase().includes(key.toLowerCase())) {
      return message
    }
  }

  // If no match found, return a cleaned up version of the original
  // Remove technical prefixes and make it more readable
  let cleanedError = error
    .replace(/^AuthApiError:\s*/i, '')
    .replace(/^Error:\s*/i, '')
    .replace(/^auth\//, '')
    .replace(/-/g, ' ')

  // Capitalize first letter
  cleanedError = cleanedError.charAt(0).toUpperCase() + cleanedError.slice(1)

  // Add period if missing
  if (!cleanedError.endsWith('.') && !cleanedError.endsWith('!') && !cleanedError.endsWith('?')) {
    cleanedError += '.'
  }

  return cleanedError
}
